let route = [{
  path: '/home',
  name: 'home',
  'component': 'home/Home',
  redirect: '/home/homePage',
  meta: {
    title: '首页'
  },
  children: [
    // 首页
    {
      path: '/home/homePage',
      name: '首页',
      'component': 'homePage/homePage',
      meta: {
        title: '首页',
      },
      children: []
    },
    //信息维护
    {
      path: '/home/informationMaintenance', //这个主路由后期需要变，这个只是测试
      name: '信息维护',
      'component': 'informationMaintenance/index',
      meta: {
        title: '信息维护',
      },
      children: [{
          path: '/home/informationMaintenance/administrationOfEducationBureau',
          name: '教育局管理',
          component: 'informationMaintenance/administrationOfEducationBureau',
          meta: {
            title: '教育局管理',
            customerType: ['0'],
            show: true
          }
        },
        {
          path: '/home/informationMaintenance/schoolManagement',
          name: '学校管理',
          component: 'informationMaintenance/schoolManagement',
          meta: {
            title: '学校管理',
            customerType: ['0', '1'],
            show: true
          }
        },
        {
          path: '/home/informationMaintenance/userManagement',
          name: '用户管理',
          component: 'informationMaintenance/userManagement',
          meta: {
            title: '用户管理',
            customerType: ['0', '1', '2'],
            show: true
          }
        },
        {
          path: '/home/informationMaintenance/thirdPartyOrganization',
          name: '第三方机构',
          component: 'informationMaintenance/thirdPartyOrganization',
          meta: {
            title: '第三方机构',
            customerType: ['0', '1'],
            show: true
          }
        },
        {
          path: '/home/informationMaintenance/schoolList',
          name: '学校列表',
          component: 'informationMaintenance/schoolList',
          meta: {
            title: '学校列表',
            customerType: ['0'],
            show: false
          }
        },
        {
          path: '/home/informationMaintenance/userList',
          name: '用户列表',
          component: 'informationMaintenance/userList',
          meta: {
            title: '用户列表',
            customerType: ['0', '1'],
            show: false
          }
        },


      ]
    },
    // 课程管理
    {
      path: '/home/classManagement',
      name: '课程管理',
      component: 'courseManagement/index',
      meta: {
        title: '课程管理'
      },
      children: [{
          path: '/home/courseManagement/courseList',
          name: '学校课程',
          component: 'courseManagement/courseList',
          meta: {
            title: '学校课程',
            customerType: ['0', '1'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/courseBase',
          name: '课程基础设置',
          component: 'courseManagement/courseBase',
          meta: {
            title: '课程基础设置',
            customerType: ['2', '3'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/uploadCourse',
          name: '上传课程',
          component: 'courseManagement/uploadCourse',
          meta: {
            title: '上传课程',
            customerType: ['3'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/completedCourses',
          name: '审核完成课程',
          component: 'courseManagement/completedCourses',
          meta: {
            title: '审核完成课程',
            customerType: ['3'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/courseManagement',
          name: '课程管理',
          component: 'courseManagement/courseManagement',
          meta: {
            title: '课程管理',
            customerType: ['2'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/institutionalCurriculum',
          name: '机构课程',
          component: 'courseManagement/institutionalCurriculum',
          meta: {
            title: '机构课程',
            customerType: ['1', '2'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/courseClassManagement',
          name: '课程班管理',
          component: 'courseManagement/courseClassManagement',
          meta: {
            title: '课程班管理',
            customerType: ['2'],
            show: true
          }
        },
        {
          path: '/home/courseManagement/workforceManagement',
          name: '排班管理',
          component: 'courseManagement/workforceManagement',
          meta: {
            title: '排班管理',
            customerType: ['2'],
            show: true
          },
        },
        {
          path: '/home/courseManagement/shiftSetting',
          name: '开班设置',
          component: 'courseManagement/shiftSetting',
          meta: {
            title: '开班设置',
            customerType: ['2'],
            show: true
          },
        },
        {
          path: '/home/courseManagement/curriculumSetting',
          name: '课程表设置',
          component: 'courseManagement/curriculumSetting',
          meta: {
            title: '课程表设置',
            customerType: ['2'],
            show: false
          }
        },
        {
          path: '/home/courseManagement/semesterStarts',
          name: '学期开班设置',
          component: 'courseManagement/semesterStarts',
          meta: {
            title: '学期开班设置',
            customerType: ['2'],
            show: false
          }
        },
        {
          path: '/home/courseManagement/registrationDetails',
          name: '报名详情',
          component: 'courseManagement/registrationDetails',
          meta: {
            title: '报名详情',
            customerType: ['2'],
            show: false
          }
        },
        {
          path: '/home/courseManagement/courseInfo',
          name: '课程详情',
          component: 'courseManagement/courseInfo',
          meta: {
            title: '课程详情',
            customerType: ['0', '1'],
            show: false
          }
        },
      ]
    },
    // 通知管理
    {
      path: '/home/notificationManagement',
      name: '通知管理',
      component: 'notificationManagement/index',
      meta: {
        title: '通知管理'
      },
      children: [{
        path: '/home/notificationManagement/governmentNotice',
        name: '政策通知',
        component: 'notificationManagement/governmentNotice',
        meta: {
          title: '政策通知',
          customerType: ['0', '1', '2'],
          show: true

        }
      }, {
        path: '/home/notificationManagement/educationalAdministrationNotice',
        name: '教务通知',
        component: 'notificationManagement/educationalAdministrationNotice',
        meta: {
          title: '教务通知',
          customerType: ['0', '1', '2'],
          show: true
        }
      }, ],
    },
    //课程评价管理
    {
      path: '/home/curriculumEvaluationManagement',
      name: '课程评价管理',
      component: 'curriculumEvaluationManagement/homePage',
      meta: {
        title: '课程评价管理'
      },
      children: [],
    },
    //订单管理
    {
      path: '/home/orderManagement',
      name: '订单管理',
      component: 'orderManagement/order-mechanism',
      meta: {
        title: '订单管理'
      },
      children: [],
    },
    //认证审核
    {
      path: '/home/certificationAudit',
      name: '认证审核',
      component: 'certificationAudit/index',
      meta: {
        title: '认证审核'
      },
      children: [{
          path: '/home/certificationAudit/agencyCertification',
          name: '机构认证',
          component: 'certificationAudit/agencyCertification',
          meta: {
            title: '机构认证',
            customerType: ['1'],
            show: true

          }
        },
        {
          path: '/home/certificationAudit/courseReview',
          name: '课程审核',
          component: 'certificationAudit/courseReview',
          meta: {
            title: '课程审核',
            customerType: ['1'],
            show: true

          }
        },
        {
          path: '/home/certificationAudit/courseCheckManage',
          name: '课程审核操作',
          component: 'certificationAudit/courseCheckManage',
          meta: {
            title: '课程审核操作',
            customerType: ['1'],
            show: false

          }
        },
      ],
    },
    //权限管理
    {
      path: '/home/authorityManagement',
      name: '权限管理',
      component: 'authorityManagement/index',
      meta: {
        title: '权限管理'
      },
      children: [{
          path: '/home/authorityManagement/roleManagement',
          name: '角色管理',
          component: 'authorityManagement/roleManagement',
          meta: {
            title: '角色管理',
            customerType: ['0', '1', '2', '3'],
            show: true

          }
        },
        {
          path: '/home/authorityManagement/account',
          name: '账号管理',
          component: 'authorityManagement/account',
          meta: {
            title: '账号管理',
            customerType: ['0', '1', '2', '3'],
            show: true

          }
        },
      ],
    },
    //申请认证
    {
      path: '/home/applyCertification',
      name: '申请认证',
      component: 'applyCertification/index',
      meta: {
        title: '申请认证'
      },
      children: [{
        path: '/home/applyCertification/certifiCation',
        name: '申请认证列表',
        component: 'applyCertification/certifiCation',
        meta: {
          title: '申请认证',
          customerType: ['0', '1', '2', '3'],
          show: false
        }
      }, {
        path: '/home/applyCertification/authenTication',
        name: '认证页面',
        component: 'applyCertification/authenTication',
        meta: {
          title: '认证页面',
          customerType: ['0', '1', '2', '3'],
          show: false
        }
      }],
    },
  ]
}, ]
export default route



// WEBPACK FOOTER //
// ./src/router/route.js